import { TranslationsProvider } from "@teliaee/telia-translate";
import React from "react";
import { getWebCommonApiUrl } from "../util/UrlUtil.mjs";
const TRANSLATIONS_APP_NAME = "contactupdate";
const ContactUpdateTranslationsProvider = (props) => {
  const { children, tier, lang, disableTranslationsStatistics, disableTranslationsFetch, isTranslationsJestEnvironment } = props;
  return /* @__PURE__ */ React.createElement(
    TranslationsProvider,
    {
      labelsUrl: "".concat(getWebCommonApiUrl(tier), "/translations/").concat(lang, "?appNames=").concat(TRANSLATIONS_APP_NAME),
      defaultApp: TRANSLATIONS_APP_NAME,
      disableStatistics: disableTranslationsStatistics,
      isTestEnvironment: isTranslationsJestEnvironment,
      disableFetch: disableTranslationsFetch,
      includeGlobalTranslations: false,
      lang,
      tier
    },
    children
  );
};
export {
  ContactUpdateTranslationsProvider,
  TRANSLATIONS_APP_NAME
};
